import { Address } from '@generated/gql/graphql';

import { addressFields } from './constants';

const getAddressFieldValues = (values: Partial<Address>): Partial<Address> =>
  Object.entries(values).reduce((fieldValues, [key, value]) => {
    if (!addressFields.includes(key as keyof Address)) {
      return fieldValues;
    }

    return {
      ...fieldValues,
      [key]: value,
    };
  }, {});

const getFieldName = (formName: string, fieldName: string) =>
  `${formName}.${fieldName}`;

export { getAddressFieldValues, getFieldName };
